/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiMemberDtoPaymentDto
 */
export interface WebApiMemberDtoPaymentDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoPaymentDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoPaymentDto
     */
    memberId?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoPaymentDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoPaymentDto
     */
    year?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoPaymentDto
     */
    paymentDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoPaymentDto
     */
    createdByName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoPaymentDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoPaymentDto
     */
    updatedAt?: Date | null;
}

/**
 * Check if a given object implements the WebApiMemberDtoPaymentDto interface.
 */
export function instanceOfWebApiMemberDtoPaymentDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoPaymentDtoFromJSON(json: any): WebApiMemberDtoPaymentDto {
    return WebApiMemberDtoPaymentDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoPaymentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'year': !exists(json, 'year') ? undefined : json['year'],
        'paymentDate': !exists(json, 'paymentDate') ? undefined : (json['paymentDate'] === null ? null : new Date(json['paymentDate'])),
        'createdByName': !exists(json, 'createdByName') ? undefined : json['createdByName'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (json['updatedAt'] === null ? null : new Date(json['updatedAt'])),
    };
}

export function WebApiMemberDtoPaymentDtoToJSON(value?: WebApiMemberDtoPaymentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'memberId': value.memberId,
        'amount': value.amount,
        'year': value.year,
        'paymentDate': value.paymentDate === undefined ? undefined : (value.paymentDate === null ? null : value.paymentDate.toISOString()),
        'createdByName': value.createdByName,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt === null ? null : value.updatedAt.toISOString()),
    };
}

